import { render, staticRenderFns } from "./FilterPlaceholder.vue?vue&type=template&id=2ce07a3e&"
import script from "./FilterPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FilterPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./FilterPlaceholder.vue?vue&type=style&index=0&id=2ce07a3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports